import { freezeWindowScroll, releaseWindowScroll, isSafari } from '../common/utils';
import { isMobile } from '../common/common';
import { dispatchGtmEvent } from '../common/gtm';
import { initSearchFunc } from './search';
export var dispatcher = getDispatcher();
export function initHeader() {
    var header = document.getElementById('siteHeader');
    var outer = header.querySelector('.siteHeader-outer');
    var inner = header.querySelector('.siteHeader-inner');
    var nav = inner.querySelector('.-nav');
    var mobile = header.querySelector('.siteHeader-mobile');
    var dropdownMenuOpen = false;
    initDroppies();
    initProductsMenu();
    initSearch();
    initMobile();
    initAutoHide();
    //dispatcher.mobile.dispatch('open')
    //dispatcher.search.dispatch('open')
    //const ii = <HTMLInputElement>header.querySelector('.-search-controls .-input')
    //ii.value = 'camera'
    //ii.dispatchEvent(new Event('keyup'))
    //dispatcher.products.dispatch('open')
    //dispatcher.ptypes.dispatch('open', 0)
    function initAutoHide() {
        var prevYOffset = window.pageYOffset;
        var lowerEdgeOffset = header.offsetTop + 100;
        var diff = 0;
        var scrollUpDistance = 0;
        var scrollDownDistance = 0;
        window.requestAnimationFrame(animate);
        function animate() {
            diff = window.pageYOffset - prevYOffset;
            if (diff && diff < window.innerHeight && window.pageYOffset !== prevYOffset) {
                if (diff > 0) {
                    // Scroll down
                    scrollDownDistance += diff;
                    scrollUpDistance = 0;
                    if (window.pageYOffset > lowerEdgeOffset && scrollDownDistance > 50 && !dropdownMenuOpen) {
                        header.classList.add('is--hidden');
                        document.body.classList.add('header--hidden');
                    }
                }
                else {
                    scrollUpDistance += -diff;
                    scrollDownDistance = 0;
                }
                if (scrollUpDistance > 150 || window.pageYOffset < lowerEdgeOffset) {
                    header.classList.remove('is--hidden');
                    document.body.classList.remove('header--hidden');
                }
                prevYOffset = window.pageYOffset;
            }
            window.requestAnimationFrame(animate);
        }
    }
    function initMobile() {
        var top = mobile.querySelector('.-top');
        var label = top.querySelector('.-label');
        var mobileNav = mobile.querySelector('.-nav');
        var triggers = [].slice.apply(document.querySelectorAll('[data-mobile-menu]'));
        triggers.forEach(function (trigger) { return trigger.addEventListener('click', function () {
            if (dispatcher.ptypes.isOpen()) {
                dispatcher.ptypes.dispatch('close');
                freezeWindowScroll();
            }
            else if (dispatcher.products.isOpen()) {
                dispatcher.products.dispatch('close');
                freezeWindowScroll();
            }
            else if (dispatcher.search.isOpen()) {
                dispatcher.search.dispatch('close');
                freezeWindowScroll();
            }
            else {
                dispatcher.mobile.dispatch(trigger.dataset.mobileMenu);
            }
        }); });
        dispatcher.products.on('open', backTriggers);
        dispatcher.search.on('open', backTriggers);
        dispatcher.products.on('close', normalTriggers);
        dispatcher.search.on('close', normalTriggers);
        function backTriggers() {
            triggers.forEach(function (trigger) { return trigger.classList.add('is--back'); });
        }
        function normalTriggers() {
            triggers.forEach(function (trigger) { return trigger.classList.remove('is--back'); });
        }
        dispatcher.on('label', function (value) {
            if (value) {
                label.innerText = value;
            }
            else {
                label.innerText = label.dataset.title;
            }
        });
        dispatcher.mobile.on('open', openMenu);
        dispatcher.mobile.on('close', closeMenu);
        window.addEventListener('resize', resolve);
        window.addEventListener('orientationchange', resolve);
        resolve();
        function openMenu() {
            freezeWindowScroll();
            triggers.forEach(function (trigger) { return trigger.classList.add('is--active'); });
            mobileNav.classList.add('is--visible');
            dropdownMenuOpen = true;
        }
        function closeMenu() {
            releaseWindowScroll();
            dispatcher.search.isOpen() && dispatcher.search.dispatch('close');
            dispatcher.products.isOpen() && dispatcher.products.dispatch('close');
            triggers.forEach(function (trigger) { return trigger.classList.remove('is--active'); });
            mobileNav.classList.remove('is--visible');
            dropdownMenuOpen = false;
        }
        /**
         * Cut and paste contents between mobile and inner headers based on window's width
         */
        function resolve() {
            if (isMobile() && header.contains(inner)) {
                header.removeChild(inner);
                header.appendChild(mobile);
                if (nav.childNodes.length) {
                    ;
                    [].slice.apply(nav.childNodes).forEach(function (node) {
                        mobileNav.appendChild(node);
                    });
                }
            }
            else if (!isMobile() && header.contains(mobile)) {
                header.removeChild(mobile);
                header.appendChild(inner);
                if (mobileNav.childNodes.length) {
                    ;
                    [].slice.apply(mobileNav.childNodes).forEach(function (node) {
                        nav.appendChild(node);
                    });
                }
            }
            if (header.classList.contains('is--loading')) {
                header.classList.remove('is--loading');
            }
        }
    }
    function initDroppies() {
        var menus = [].slice.apply(header.querySelectorAll('li.menu-item-has-children'));
        menus.forEach(function (li) {
            var a = [].slice.apply(li.childNodes).find(function (node) { return node.nodeName === 'A'; }), subMenu = li.querySelector('.sub-menu');
            initDroppie(a, subMenu);
        });
        initDroppie(header.querySelector('.-activeLang'), header.querySelector('.-languages'));
        function initDroppie(trigger, menu) {
            var isOpen = false;
            if (!trigger && !menu) {
                trigger && (trigger.disabled = true);
                return;
            }
            var menuId = menu.getAttribute('id') || "menu-".concat(Math.round(Math.random() * 1000000));
            menu.setAttribute('id', menuId);
            menu.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-controls', menuId);
            trigger.addEventListener('click', function (event) {
                if (!isMobile()) {
                    event.preventDefault();
                    toggleMenu();
                }
            });
            document.addEventListener('click', function (event) {
                if (isOpen && (event.target !== trigger && event.target !== menu && !menu.contains(event.target))) {
                    closeMenu();
                }
            });
            window.addEventListener('beforeunload', function (event) {
                isOpen && closeMenu();
            });
            function openMenu() {
                trigger.setAttribute('aria-expanded', 'true');
                menu.setAttribute('aria-hidden', 'false');
                menu.classList.add('is--open');
                trigger.classList.add('is--active');
                isOpen = true;
                dispatchGtmEvent('AC.Interaction.Menu.open', {
                    label: trigger.innerText,
                });
            }
            function closeMenu() {
                trigger.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-hidden', 'true');
                menu.classList.remove('is--open');
                trigger.classList.remove('is--active');
                isOpen = false;
                dispatchGtmEvent('AC.Interaction.Menu.close', {
                    label: trigger.innerText,
                });
            }
            function toggleMenu() {
                isOpen ? closeMenu() : openMenu();
            }
        }
    }
    function initProductsMenu() {
        var menu = outer.querySelector('.-products');
        var triggers = [].slice.apply(document.querySelectorAll('[data-products-menu]'));
        if (!menu) {
            console.info("Skipping products mega menu - root element not found");
            return;
        }
        var animationFrame = null, animationHandler = function () { };
        initMenuInternals();
        triggers.forEach(function (trigger) { return trigger.addEventListener('click', function () { return dispatcher.products.dispatch(trigger.dataset.productsMenu); }); });
        dispatcher.products.on('close', closeMenu);
        dispatcher.products.on('open', openMenu);
        function openMenu() {
            dispatcher.search.isOpen() && dispatcher.search.dispatch('close');
            isMobile() || dispatcher.ptypes.dispatch('open', 0);
            showOuter();
            menu.classList.add('is--visible');
            triggers.forEach(function (trigger) { return trigger.classList.add('is--active'); });
            dispatcher.label.set(menu.getAttribute('aria-label'));
            if (!isSafari()) {
                animationFrame = window.requestAnimationFrame(animationHandler);
            }
        }
        function closeMenu() {
            hideOuter();
            menu.classList.remove('is--visible');
            triggers.forEach(function (trigger) { return trigger.classList.remove('is--active'); });
            dispatcher.label.reset();
            window.cancelAnimationFrame(animationFrame);
        }
        function initMenuInternals() {
            var triggers = [].slice.apply(menu.querySelectorAll('.-type')), collections = [].slice.apply(menu.querySelectorAll('.-collection')), scroller = menu.querySelector('.-products-list-scroller');
            if (!triggers.length || !collections.length) {
                console.warn('No product type triggers and collections found');
                return;
            }
            dispatcher.ptypes.on('open', pickType);
            dispatcher.ptypes.on('close', discardTypes);
            triggers.forEach(function (trigger, idx) {
                trigger.addEventListener('click', function () { return dispatcher.ptypes.dispatch('open', idx, trigger); });
            });
            // Collection header parallax on overflow scrolling
            // Minimizing calculations only to currently active collection
            // No heavy shit inside animation frame handler!
            var activeCollection = null, activeCollectionHeader = null, activeCollectionList = null;
            animationHandler = function animationHandler() {
                if (!isMobile() && activeCollection) {
                    if (activeCollection.scrollTop > 0) {
                        activeCollectionList.classList.add('is--scrolled');
                        activeCollectionHeader.style.transform = "translateY(".concat(activeCollection.scrollTop / 2.5, "px)");
                        //activeCollectionHeader.style.opacity = (1 - activeCollection.scrollTop / activeCollectionHeader.scrollHeight).toString()
                    }
                    else {
                        activeCollectionList.classList.remove('is--scrolled');
                        activeCollectionHeader.style.transform = '';
                    }
                }
                animationFrame = window.requestAnimationFrame(animationHandler);
            };
            function pickType(idx) {
                if (idx === void 0) { idx = 0; }
                var trigger = triggers[idx], collection = collections[idx];
                discardTypes();
                activeCollection = collection;
                activeCollectionHeader = collection.querySelector('.-collection-header');
                activeCollectionList = collection.querySelector('.-collection-list');
                scroller.classList.add("is--index-".concat(idx));
                trigger.classList.add('is--active');
                collection.classList.add('is--visible');
                [].slice.apply(collection.querySelectorAll('img[data-src]')).forEach(function (img) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                });
            }
            function discardTypes() {
                activeCollection = null;
                activeCollectionHeader = null;
                activeCollectionList = null;
                triggers.filter(function (t) { return t.classList.contains('is--active'); }).forEach(function (t) { return t.classList.remove('is--active'); });
                collections.filter(function (c) { return c.classList.contains('is--visible'); })
                    .forEach(function (c) { return c.classList.remove('is--visible'); });
                scroller.className = scroller.className.replace(/is--index-\d+/, '');
            }
        }
    }
    function initSearch() {
        var triggers = [].slice.apply(document.querySelectorAll('[data-search-dialog]'));
        var searcher = outer.querySelector('.-search');
        var resultsShadow = searcher.querySelector('.-search-resultsShadow');
        var input = searcher.querySelector('.-input');
        var link = searcher.querySelector('.-link');
        var resultsContainer = searcher.querySelector('.-search-results');
        var searchFunc = initSearchFunc({ input: input, resultsContainer: resultsContainer });
        dispatcher.search.on('close', closeMenu);
        dispatcher.search.on('open', openMenu);
        dispatcher.search.on('close', function () { return searchFunc.clear(); });
        triggers.forEach(function (trigger) { return trigger.addEventListener('click', function () { return dispatcher.search.dispatch(trigger.dataset.searchDialog); }); });
        initResultsShadow();
        input.addEventListener('keydown', function (event) {
            switch (event.key) {
                case 'Enter':
                    if (input.value) {
                        (Object.assign(document.createElement('a'), {
                            href: "/?s=".concat(encodeURIComponent(input.value)),
                        })).click();
                    }
                    break;
                case 'Esc':
                case 'Escape':
                    closeMenu();
                    break;
            }
        });
        input.addEventListener('keyup', function (event) {
            if (input.value) {
                link.classList.add('is--active');
                link.href = "/?s=".concat(encodeURIComponent(input.value));
            }
            else {
                link.classList.remove('is--active');
                link.href = '';
            }
        });
        function openMenu() {
            dispatcher.products.isOpen() && dispatcher.products.dispatch('close');
            showOuter();
            searcher.classList.add('is--visible');
            triggers.forEach(function (trigger) { return trigger.classList.add('is--active'); });
            setTimeout(function () { return input.focus(); }, 150);
            dispatcher.label.set(searcher.getAttribute('aria-label'));
            dispatchGtmEvent('AC.interaction.search.open');
        }
        function closeMenu() {
            hideOuter();
            searcher.classList.remove('is--visible');
            triggers.forEach(function (trigger) { return trigger.classList.remove('is--active'); });
            dispatcher.label.reset();
            dispatchGtmEvent('AC.interaction.search.close');
        }
        function initResultsShadow() {
            var maxHeight = 0, scrollTop = 0, pad = 5;
            updateHeight();
            window.addEventListener('resize', updateHeight);
            resultsContainer.addEventListener('scroll', function (event) {
                scrollTop = resultsContainer.scrollTop;
                if (scrollTop > maxHeight) {
                    resultsShadow.style.opacity = '1';
                }
                else if (scrollTop < pad) {
                    resultsShadow.style.opacity = '0';
                }
                else {
                    resultsShadow.style.opacity = (scrollTop / (maxHeight - pad)).toString();
                }
            });
            function updateHeight() {
                maxHeight = window.innerHeight / 2;
            }
        }
    }
    function showOuter() {
        freezeWindowScroll();
        outer.classList.add('is--visible');
    }
    function hideOuter() {
        releaseWindowScroll();
        outer.classList.remove('is--visible');
    }
}
//function blurBackdrop() {
//  document.documentElement.classList.contains('has--filter') && document.body.classList.add('blur-backdrop')
//}
//function resetBackdrop() {
//  document.body.classList.remove('blur-backdrop')
//}
function getDispatcher() {
    function listen(action, cb) {
        document.addEventListener("header-".concat(action), function (event) {
            cb(event.detail);
        });
    }
    function dispatch(action, detail, origin) {
        (origin || document).dispatchEvent(new CustomEvent("header-".concat(action), {
            bubbles: true,
            cancelable: true,
            detail: detail,
        }));
    }
    function stdMenu(name) {
        var isOpen = false;
        return {
            isOpen: function () {
                return isOpen;
            },
            dispatch: function (action, detail, origin) {
                switch (action) {
                    case 'open':
                        isOpen = true;
                        break;
                    case 'close':
                        isOpen = false;
                        break;
                    case 'toggle':
                    default:
                        var directive = isOpen ? 'close' : 'open';
                        this.dispatch(directive);
                        dispatch("".concat(name, "-toggle"), directive, origin);
                }
                dispatch("".concat(name, "-").concat(action), detail, origin);
            },
            on: function (action, cb) {
                listen("".concat(name, "-").concat(action), cb);
            },
        };
    }
    return {
        dispatch: dispatch,
        on: listen,
        mobile: stdMenu('mobile'),
        products: stdMenu('products'),
        ptypes: stdMenu('ptypes'),
        search: stdMenu('search'),
        label: {
            set: function (label) { return dispatch('label', label); },
            reset: function () { return dispatch('label'); },
        },
    };
}
